import type { TokenRequestParams } from '../schema/TokenRequestParams';
import { getUserToken } from './userTokenHandler';

export async function getUserTokenIfAvailable(
    params: TokenRequestParams
): Promise<string | undefined> {
    return getUserToken(params.mailboxInfo);
}
